/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudAccountUpdate
 */
export interface CloudAccountUpdate {
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    provider?: CloudAccountUpdateProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    accessId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    secret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    tenant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    subscription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountUpdate
     */
    mountCredentialsManagement?: CloudAccountUpdateMountCredentialsManagementEnum;
}

/**
* @export
* @enum {string}
*/
export enum CloudAccountUpdateProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}/**
* @export
* @enum {string}
*/
export enum CloudAccountUpdateMountCredentialsManagementEnum {
    Null = 'null',
    Share = 'share',
    Token = 'token'
}

export function CloudAccountUpdateFromJSON(json: any): CloudAccountUpdate {
    return CloudAccountUpdateFromJSONTyped(json, false);
}

export function CloudAccountUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudAccountUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'accessId': !exists(json, 'access_id') ? undefined : json['access_id'],
        'secret': !exists(json, 'secret') ? undefined : json['secret'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'mountCredentialsManagement': !exists(json, 'mount_credentials_management') ? undefined : json['mount_credentials_management'],
    };
}

export function CloudAccountUpdateToJSON(value?: CloudAccountUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'provider': value.provider,
        'access_id': value.accessId,
        'secret': value.secret,
        'tenant': value.tenant,
        'subscription': value.subscription,
        'endpoint': value.endpoint,
        'mount_credentials_management': value.mountCredentialsManagement,
    };
}


